<template>
    <div class="device-type-add">
        <el-page-header @back="goBack" content="编辑特属服务对象"></el-page-header>
        <el-form label-position="right" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="form"
                 :style="{width: form_width,margin: '20px auto 0 auto'}"  autocomplete="off">
            <el-form-item label="特属服务对象姓名" prop="user_name" v-if="is_user_name">
                <el-input type="text" v-model="ruleForm.user_name" placeholder="请输入特属服务对象姓名" maxlength="5"
                          @input="userNameCheck" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="特属服务对象姓名" prop="user_name" class="is-error" v-else>
                <el-input type="text" v-model="ruleForm.user_name" placeholder="请输入特属服务对象姓名" maxlength="5"
                          @input="userNameCheck" autocomplete="off"
                          style="width: 100%;"></el-input>
                <div class="el-form-item__error">请输入2-5个字的中文姓名</div>
            </el-form-item>
            <el-form-item label="手机号码" prop="mobile">
                <el-input type="text" v-model="ruleForm.mobile" maxlength="11" placeholder="请输入手机号码" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="身份证号码">
                <el-input type="text" v-model="ruleForm.idcard" maxlength="18" placeholder="请输入身份证号码" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="所属集团" prop="bloc_id">
                <el-select v-model="ruleForm.bloc_id" placeholder="请选择所属集团" style="width: 100%;">
                    <el-option
                        v-for="item in allBloc"
                        :key="item.id"
                        :label="item.bloc_name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="尊称" prop="nick_name">
                <el-input type="text" v-model="ruleForm.nick_name" placeholder="请输入尊称（限3字）" autocomplete="off"
                          style="width: 100%;" maxlength="3"></el-input>
            </el-form-item>
            <el-form-item label="职务">
                <el-input type="text" v-model="ruleForm.posistion" placeholder="请输入职务（限6字）" autocomplete="off"
                          style="width: 100%;" maxlength="6"></el-input>
            </el-form-item>
            <el-form-item label="运营负责公司" prop="company_id">
                <el-select v-model="ruleForm.company_id" placeholder="请选择运营负责公司" style="width: 100%;"
                           @change="changeCompany">
                    <el-option
                        v-for="item in allCompany"
                        :key="item.id"
                        :label="item.company_name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="运营负责部门">
                <el-select v-model="ruleForm.department_id" placeholder="请选择运营负责部门" style="width: 100%;"
                           @change="changeDeparment">
                    <el-option value="">请选择</el-option>
                    <el-option
                        v-for="item in allDepartment"
                        :key="item.id"
                        :label="item.department_name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="运营负责组">
                <el-select v-model="ruleForm.group_id"  @change="changeGroup" placeholder="请选择运营负责组" style="width: 100%;">
                    <el-option value="">请选择</el-option>
                    <el-option
                        v-for="item in allGroup"
                        :key="item.id"
                        :label="item.group_name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="特属服务专员">
                <el-select
                    clearable
                    v-model="ruleForm.operate_user_id" placeholder="请选择特属服务专员"
                           style="width: 100%;">
                    <el-option value="">请选择</el-option>
                    <el-option
                        v-for="item in allGroupUser"
                        :key="item.id"
                        :label="item.user_name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="状态" prop="status">
                <el-radio-group v-model="ruleForm.status">
                    <el-radio :label="1">启用</el-radio>
                    <el-radio :label="2">停用</el-radio>
                </el-radio-group>
            </el-form-item>
<!--            <el-form-item label="健康管理服务费" prop="is_expired">-->
<!--                <el-radio-group v-model="ruleForm.is_expired">-->
<!--                    <el-radio :label="1">未缴纳</el-radio>-->
<!--                    <el-radio :label="2">已缴纳</el-radio>-->
<!--                </el-radio-group>-->
<!--            </el-form-item>-->
            <el-form-item label="头像">
                <div class="avatar-uploader">
                    <label class="avatar-btn" for="uploads">
                        <img style=" width: 200px;height: 200px;" v-if="userAvaratImageUrl" :src="userAvaratImageUrl"
                             class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </label>
                </div>
                <input type="file" id="uploads" style="position:absolute; clip:rect(0 0 0 0);"
                       accept="image/png, image/jpeg, image/gif, image/jpg" @change="selectImg($event)">
            </el-form-item>


            <el-form-item>
                <el-button @click="goBack">取消</el-button>
                <el-button type="success" @click="submitForm('ruleForm')">保存</el-button>
            </el-form-item>
        </el-form>

        <el-dialog title="头像裁剪" :visible.sync="dialogVisible" append-to-body @close="closeDialog">
            <div class="cropper-content">
                <div class="cropper" style="text-align:center">
                    <vue-cropper
                        ref="cropper"
                        :img="option.img"
                        :autoCrop="true"
                        :fixed="true"
                        :fixedNumber="[1, 1]">
                    </vue-cropper>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <label class="el-button el-button--primary" for="suploads" style="margin-right: 10px;"><span>重新选择</span></label>
                <input type="file" id="suploads" style="position:absolute; clip:rect(0 0 0 0);"
                       accept="image/png, image/jpeg, image/gif, image/jpg" @change="selectImg($event)">
                <el-button type="primary" @click="uploadImg('blob')" :loading="loading">确认</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import env from "@/api/env";
import {getUserInfos} from '@/utils/userInfos';
import {check} from "@/utils/checkData";
import {VueCropper} from 'vue-cropper'
import {isMobile, userNameCheck} from "@/api/order";

export default {
    components: {
        VueCropper
    },
    created() {
        if (isMobile()) {
            this.form_width = "100%"
        }
        localStorage.setItem('prev_page', 'user_edit')
        this.user_id = this.$route.params.user_id || this.$route.query.user_id;
        let userData = getUserInfos();
        this.ruleForm.input_user_name = userData.user_name;
    },
    mounted() {
        this.createParams();
    },
    data() {
        return {
            user_id: '',
            upload_path: env.IMG_COMMON_REQUEST_URL_PREFIX + '?type=1',
            userAvaratImageUrl: '',
            imgUrl: env.IMG_COMMON_URL_PREFIX,
            allBloc: [],
            allDepartment: [],
            allGroup: [],
            allCompany: [],
            allGroupUser: [],
            ruleForm: {
                user_name: "",
                mobile: "",
                idcard: "",
                bloc_id: "",
                company_id: "",
                group_id: "",
                department_id: "",
                nick_name: "",
                status: 1,
                is_expired: 2,
                user_avatar: "",
                posistion: "",
                operate_user_id: "",
            },
            rules: {
                user_name: [
                    {required: true, message: "请输入特属服务对象姓名", trigger: "blur"},
                ],
                mobile: [
                    {required: true, message: "请输入手机号码", trigger: "blur"},
                ],
                idcard: [
                    {required: true, message: "请输入身份证号码", trigger: "blur"},
                ],
                bloc_id: [
                    {required: true, message: "请选择所属集团", trigger: "blur"},
                ],
                company_id: [
                    {required: true, message: "请选择所属公司", trigger: "blur"},
                ],
                department_id: [
                    {required: true, message: "请选择所属部门", trigger: "blur"},
                ],
                group_id: [
                    {required: true, message: "请选择所属组", trigger: "blur"},
                ],
                nick_name: [
                    {required: true, message: "请输入尊称", trigger: "blur"},
                ],
                posistion: [
                    {required: true, message: "请输入职称", trigger: "blur"},
                ],
                status: [
                    {required: true, message: "请选择状态", trigger: "blur"},
                ],
                is_expired: [
                    {required: true, message: "请选择健康管理服务费状态", trigger: "blur"},
                ],

            },
            dialogVisible: false,
            // 防止重复提交
            loading: false,
            option: {
                img: '',             //裁剪图片的地址
            },
            is_submit: false,
            is_user_name: true, // 用户名输入是否正确
            form_width: "40%",
        };
    },
    methods: {
        // 用户名中文验证
        userNameCheck(e) {
            if (e) {
                this.is_user_name = userNameCheck(e)
            } else {
                this.is_user_name = true
            }
        },
        //
        createParams() {
            let params = {
                servername: 'Ruyi_AdminCustomerServices',
                method: 'createEditUserParams',
                params: {
                    user_id: this.user_id
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                this.allBloc = res.data.data.bloc;
                this.allCompany = res.data.data.company;
                this.userDetail();

            });
        },

        // 用户详情
        userDetail() {
            let params = {
                servername: 'Ruyi_AdminCustomerServices',
                method: 'editUserDetail',
                params: {
                    user_id: this.user_id
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }

                this.ruleForm.user_name = res.data.data.user_name;
                this.ruleForm.mobile = res.data.data.mobile;
                this.ruleForm.idcard = res.data.data.idcard;
                this.ruleForm.bloc_id = res.data.data.bloc_id;
                this.ruleForm.manager_id = res.data.data.manager_id;
                this.ruleForm.nick_name = res.data.data.nick_name;
                this.ruleForm.company_id = res.data.data.company_id;
                this.ruleForm.department_id = res.data.data.department_id;
                this.ruleForm.group_id = res.data.data.group_id;
                this.ruleForm.status = parseInt(res.data.data.status);
                this.ruleForm.is_expired = parseInt(res.data.data.is_expired);
                this.ruleForm.user_avatar = res.data.data.user_avatar;
                this.ruleForm.posistion = res.data.data.posistion;
                if (res.data.data.operate_user_id > 0) {
                    this.ruleForm.operate_user_id = res.data.data.operate_user_id;
                } else {
                    this.ruleForm.operate_user_id = '';
                }

                if (res.data.data.user_avatar) {
                    this.userAvaratImageUrl = this.imgUrl + res.data.data.user_avatar;
                }

                this.getAllDeparment();
                this.getAllCompanyGroup();
                this.changeGroup()
            });
        },

        // 返回上一页
        goBack() {
            window.history.go(-1);
            return;

        },

        // 提交表单
        submitForm(formName) {
            if (this.is_submit) {
                // 重复提交提醒
                this.$message({
                    type: "warning",
                    message: '正在处理请求，请不要重复提交',
                    duration: 1500,
                });
                return;
            }
            this.is_submit = true;
            let _that = this
            this.$refs[formName].validate(valid => {
                if (valid) {
                    let params = {
                        'servername': 'Ruyi_AdminCustomerServices',
                        'method': 'editUser',
                        'params': {
                            user_id: this.user_id,
                            user_name: this.ruleForm.user_name,
                            mobile: this.ruleForm.mobile,
                            idcard: this.ruleForm.idcard,
                            bloc_id: this.ruleForm.bloc_id,
                            manager_id: this.ruleForm.manager_id,
                            nick_name: this.ruleForm.nick_name,
                            status: this.ruleForm.status,
                            is_expired: this.ruleForm.is_expired,
                            posistion: this.ruleForm.posistion,
                            user_avatar: this.ruleForm.user_avatar,
                            company_id: this.ruleForm.company_id,
                            department_id: this.ruleForm.department_id,
                            group_id: this.ruleForm.group_id,
                            operate_user_id: this.ruleForm.operate_user_id,
                        }
                    };
                    this.$api.service(params).then(res => {
                        if (!check(res)) {
                            this.is_submit = false;
                            return;
                        }
                        this.$message({
                            type: "success",
                            message: '编辑成功',
                            duration: 1500,
                            onClose: function () {
                                _that.is_submit = false;
                                window.history.go(-1);
                                return;
                            }
                        });
                    }).catch(()=>{
                        this.is_submit = false;
                    }).finally(() => {
                        this.is_submit = false;
                    });
                } else {
                    this.$message({
                        type: "error",
                        message: '请输入必填项'
                    });
                    this.is_submit = false;
                    return false;
                }
            });
        },
        // 获取组成员
        changeGroup() {
            if (this.ruleForm.group_id < 1) return;
            let params = {
                servername: 'Ruyi_AdminOperateServices',
                method: 'getAllGroupUser',
                params: {
                    company_id: this.ruleForm.company_id,
                    department_id: this.ruleForm.department_id,
                    group_id: this.ruleForm.group_id,
                    status: 1
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                this.allGroupUser = res.data.data;
            });
        },
        // 上传身份证正面图片
        handleUserAvatarImgSuccess(res) {
            if (res.code == 0) {
                this.ruleForm.user_avatar = res.data;
                this.userAvaratImageUrl = this.imgUrl + res.data;
            } else {
                this.$message({
                    type: "error",
                    message: res.msg,
                });
            }
        },

        //上传图片之前，检测文件格式
        beforeAvatarUpload(file) {
            if (file.type === 'image/jpeg' || file.type === 'image/png') {
                var isJPG = true;
            } else {
                var isJPG = false;
            }
            const isLt5M = file.size / 1024 / 1024 < 5;
            if (!isJPG) {
                this.$message.error('图片只能是jpg/png格式!');
            }
            if (!isLt5M) {
                isJPG = false;
                this.$message.error('图片大小不能超过5MB!');

            }
            return isJPG;
        },
        changeCompany() {
            this.ruleForm.department_id = '';
            this.ruleForm.group_id = '';
            this.getAllDeparment();
        },
        changeDeparment() {
            this.ruleForm.group_id = '';
            this.getAllCompanyGroup();
        },
        getAllDeparment() {
            let params = {
                servername: 'Ruyi_AdminOperateServices',
                method: 'getAllCompanyDeparment',
                params: {
                    company_id: this.ruleForm.company_id,
                    status: 1
                }
            };
            this.allDepartment = [];
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                this.allDepartment = res.data.data;
            });
        },

        getAllCompanyGroup() {
            let params = {
                servername: 'Ruyi_AdminOperateServices',
                method: 'getAllCompanyGroup',
                params: {
                    company_id: this.ruleForm.company_id,
                    department_id: this.ruleForm.department_id,
                    status: 1
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                this.allGroup = res.data.data;
            });
        },

        //选择图片
        selectImg(e) {
            let file = e.target.files[0]
            if (!/\.(jpg|jpeg|png|JPG|PNG)$/.test(e.target.value)) {
                this.$message({
                    message: '图片类型要求：jpeg、jpg、png',
                    type: "error"
                });
                return false
            }
            //转化为blob
            let reader = new FileReader()
            reader.onload = (e) => {
                let data
                if (typeof e.target.result === 'object') {
                    data = window.URL.createObjectURL(new Blob([e.target.result]))
                } else {
                    data = e.target.result
                }
                this.option.img = data
                this.dialogVisible = true;
            }
            //转化为base64
            reader.readAsDataURL(file)
        },
        //上传图片
        uploadImg(type) {
            let _this = this;
            if (type === 'blob') {
                //获取截图的blob数据
                this.$refs.cropper.getCropBlob(async (data) => {
                    let formData = new FormData();
                    formData.append('file', data, ".jpg")

                    await _this.$api.avatar_upload_file(formData).then(res => {
                        if (!check(res)) {
                            return;
                        }
                        if (res.data.code == 0) {
                            _this.ruleForm.user_avatar = res.data.data;
                            _this.userAvaratImageUrl = this.imgUrl + res.data.data;
                            _this.dialogVisible = false;
                        } else {
                            _this.$message({
                                type: "error",
                                message: res.data.msg,
                            });
                        }
                    })

                })
            }
        },
        // 关闭对话框清除之前选择的文件
        closeDialog() {
            document.getElementById('uploads').value = ''
            document.getElementById('suploads').value = ''
        }

    }

};
</script>
<style lang="scss">
@import "@/styles/common.scss";

.cropper-content {
    .cropper {
        width: auto;
        height: 300px;
    }
}

.avatar-btn, .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-btn {
    display: inline-block;
    text-align: center;
}

.avatar-btn, .avatar-uploader .el-upload:hover {
    border-color: #d9d9d9;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 200px;
    height: 200px;
    line-height: 200px;
    text-align: center;
}

.avatar-btn {
    width: 200px;
    height: 200px;
}

.editor {
    line-height: normal !important;
    height: 800px;
}

.ql-snow .ql-tooltip[data-mode=link]::before {
    content: "请输入链接地址:";
}

.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
    border-right: 0px;
    content: '保存';
    padding-right: 0px;
}

.ql-snow .ql-tooltip[data-mode=video]::before {
    content: "请输入视频地址:";
}

.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
    content: '14px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
    content: '10px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
    content: '18px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
    content: '32px';
}

.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
    content: '文本';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
    content: '标题1';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
    content: '标题2';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
    content: '标题3';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
    content: '标题4';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
    content: '标题5';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
    content: '标题6';
}

.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
    content: '标准字体';
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
    content: '衬线字体';
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
    content: '等宽字体';
}
</style>
